import * as React from "react";
import { makeStyles } from "@material-ui/core";
import { Colors } from "styles/Colors";

const TROUGH_RADIUS = 999;
const TROUGH_PADDING = 4;
const TROUGH_BORDER = 1;

const useStyles = makeStyles(() => {
	return {
		trough: {
			display: "inline-flex",
			alignItems: "stretch",
			height: 34,
			gap: TROUGH_PADDING,
			padding: TROUGH_PADDING,
			borderRadius: TROUGH_RADIUS,
			border: `${TROUGH_BORDER}px solid rgba(255, 255, 255, 0.16)`,
			backgroundColor: "rgba(0, 0, 0, 0.5)",
			boxSizing: "border-box",
			userSelect: "none",
		},
		item: {
			display: "inline-flex",
			alignItems: "center",
			gap: 6,
			padding: "0 16px",
			border: 0,
			margin: 0,
			backgroundColor: "transparent",
			color: Colors.primaryDark,
			cursor: "pointer",
			fontFamily: "inherit",
			fontSize: 10,
			fontWeight: 600,
			lineHeight: 1,
			letterSpacing: "0.15em",
			textTransform: "uppercase",
			borderRadius: TROUGH_RADIUS - TROUGH_PADDING - TROUGH_BORDER,
			transition: "color 200ms ease, background-color 200ms ease",
			WebkitTapHighlightColor: "transparent",
			outline: "none",

			"&:hover": {
				color: Colors.primary,
				backgroundColor: "rgba(255, 255, 255, 0.06)",
			},

			"&:active": {
				backgroundColor: "rgba(255, 255, 255, 0.10)",
			},

			"&:focus-visible": {
				boxShadow: `0 0 0 2px ${Colors.pickstop}`,
			},

			"&.selected, &.selected:hover, &.selected:active": {
				backgroundColor: "rgba(255, 255, 255, 0.13)",
				color: Colors.pickstop,
				fontWeight: 700,
			},
		},
		label: {
			transform: "translateY(0.07em)",
		},
	};
});

/** Compact view switch. TabToggle is the larger variant used for league nav. */
export default function ViewToggle({ value, items, onChange, className }) {
	const styles = useStyles();

	return (
		<div className={styles.trough + (className ? " " + className : "")}>
			{items.map((i) => (
				<button
					key={i.id}
					type="button"
					className={styles.item + (value === i.id ? " selected" : "")}
					onClick={() => {
						if (value !== i.id) {
							onChange(i.id);
						}
					}}
				>
					<span className={styles.label}>{i.text}</span>
				</button>
			))}
		</div>
	);
}
